import * as yup from 'yup';
import { puzzleNameValidator } from 'validations/string';

import { strings } from '../strings';

export enum UploadField {
  Name = 'name',
  Keywords = 'keywords',
  Collection = 'collection',
  Collections = 'collections',
  Image = 'image',
  ArtistId = 'Publisher',
  PremiumTier = 'premiumTier',
  SecondaryCollection = 'secondaryCollection',
  AIGenerated = 'aiGenerated',
  Status = 'status',
  ForceSetPublishDate = 'forceSetPublishDate',
  RejectMessage = 'rejectMessage',
}

export const uploadSchema = yup.object().shape({
  [UploadField.Name]: puzzleNameValidator(),
  [UploadField.Keywords]: yup.string().trim().required(strings.collectionKeywordsRequired),
  [UploadField.Collection]: yup
    .object()
    .shape({
      label: yup.string(),
      value: yup.string(),
    })
    .nullable()
    .required(strings.collectionIsRequired),
});

const collectionOptionSchema = yup.object().shape({
  label: yup.string(),
  value: yup.string().required(strings.collectionIsRequired),
});

export const uploadPuzzleSchema = yup.object().shape({
  [UploadField.Name]: puzzleNameValidator(),
  [UploadField.Keywords]: yup.string().trim().required(strings.collectionKeywordsRequired),
  [UploadField.Collections]: yup
    .array()
    .of(collectionOptionSchema)
    .required(strings.collectionIsRequired)
    .min(1, strings.collectionIsRequired)
    .test('unique-collections', 'Puzzle can not have two same categories!', (collections) => {
      if (!collections) {
        return true;
      }

      const values = collections.map((collection) => collection?.value).filter(Boolean);

      return values.length === new Set(values).size;
    }),
});

export const uploadVideoSchema = uploadPuzzleSchema.shape({
  [UploadField.Status]: yup
    .object({
      label: yup.string(),
      value: yup.string().required(strings.statusRequired),
    })
    .required(strings.statusRequired),
});
